import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../services/user.service';
import { RoleService } from '../../../services/role.service';
import { CommonService } from '../../../services/common.service';
import { MustMatch } from '../../../_helpers/must-match.validator';
import { CustomValidators } from 'ng2-validation';
import * as moment from 'moment-timezone';
import { environment } from 'src/environments/environment';
import { maxYearFunction } from '../../../_helpers/utility';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { FileUpload } from 'primeng/fileupload';
@Component({
    selector: 'app-admin-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss'],
    providers: [MessageService]
})
export class AdminAddComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    userForm: FormGroup;
    errorMessage = '';
    submitted = false;
    uploadedFiles: any[] = [];
    file: File;
    countrylist: any = [];
    statelist: any = [];
    citylist: any = [];
    reader: FileReader;
    public profilepic;
    adminRoleId;
    statuses: any = [];
    genders: any = [];
    userstatus: any;
    usergender: any;
    countryname;
    countrycode;
    statename;
    statecode;
    cityname;
    citycode;
    public defaultDate: Date = new Date(environment.defaultDate);
    //dob: Date;
    minYear = environment.minYear;
    yearRange;
    timeZoneArray = [];
    timeZoneOffset;
    timeZone;
    rolearray: any[];
    @ViewChild('fileUpload') fileUpload!: FileUpload;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropDialog: boolean = false;
    selectedFile: File | null = null;
    imageSize = 1000000;
    croppedImageMaxSize = 1000000;
    croppedImageSize = 0;
    croppedImageError: string | null = null;
    scale = 1;
    transform: ImageTransform = {};
    cropApplied = false;
    isApplyingCrop = false;
    isSubmitting = false;
    private acceptedProfileFile: File | null = null;
    private previousAcceptedProfileFile: File | null = null;
    private previousUploadedFiles: any[] = [];
    private previousProfilepic: any = null;

    constructor(private roleService: RoleService, private commonService: CommonService, private userService: UserService, private formBuilder: FormBuilder, private messageService: MessageService,
        private router: Router) { }

    ngOnInit(): void {
        const timeZones = moment.tz.names();
        for (const timezone of timeZones) {
            this.timeZoneArray.push({ name: timezone, code: moment().tz(timezone).format('Z') });
        }
        this.defaultDate.setDate(this.defaultDate.getDate() - 5);
        this.yearRange = this.minYear + ":" + maxYearFunction();
        this.statuses = [
            { label: 'Active', value: true },
            { label: 'In-Active', value: false }
        ];
        this.genders = [
            { name: 'Male', code: 'Male' },
            { name: 'Female', code: 'Female' },
            { name: 'Other', code: 'Other' },
        ];
        this.userstatus = true;
        this.timeZone = moment.tz.guess();
        this.timeZoneOffset = moment().tz(this.timeZone).format('Z');
        this.userForm = this.formBuilder.group({
            firstName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
            lastName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
            email: ['', [Validators.required, Validators.email, CustomValidators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', Validators.required],
            mobileNumber: [null, [Validators.required, Validators.pattern("^[0-9]*$")]],
            address: [''],
            country: ['', Validators.required],
            state: [''],
            city: [''],
            zipcode: [''],
            status: [{ label: 'Active', value: true }, Validators.required],
            disable: [false],
            gender: ['', Validators.required],
            dob: ['', Validators.required],
            timeZone: [{ name: this.timeZone, code: this.timeZoneOffset }, Validators.required],
            role:["", Validators.required]
        }, {
            validator: MustMatch('password', 'confirmPassword')
        });
        // this.getRoleid();
        this.getCountry();
        this.getRoleList()
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.userForm.controls;
    }
    
    onFileSelect(event: any) {
        const file = event.files[0];
        if (!file) return;

        this.capturePreviousImage();
        this.cropApplied = false;
        if (file.size > this.imageSize) {
            this.rejectOversizedImage();
            return;
        }

        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = file;
        this.isApplyingCrop = false;
        this.resetZoom();
        this.imageChangedEvent = {
            target: {
                files: [file]
            }
        };
        this.cropDialog = true;
    }

    get cropDialogTitle(): string {
        return 'Crop & Adjust Profile Photo';
    }

    get cropDialogSubtitle(): string {
        return 'Position and scale the image for a 512 x 512 crop';
    }

    get cropPreviewLabel(): string {
        return '512 x 512 px - High Quality JPEG';
    }

    zoomIn() {
        this.scale = Math.min(3, Number((this.scale + 0.1).toFixed(1)));
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    zoomOut() {
        this.scale = Math.max(1, Number((this.scale - 0.1).toFixed(1)));
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    resetZoom() {
        this.scale = 1;
        this.transform = {
            ...this.transform,
            scale: 1
        };
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
        this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
            ? 'Cropped image size must not exceed 1 MB.'
            : null;
    }

    onCropImageLoadFailed() {
        this.croppedImage = null;
        this.croppedImageSize = 0;
        this.croppedImageError = 'This image could not be loaded. Please choose a valid image file.';
    }

    getBase64SizeBytes(base64: string): number {
        if (!base64) return 0;
        return Math.round(
            (base64.length * (3 / 4)) -
            (base64.split(',')[0].length + 1)
        );
    }

    applyCrop() {
        if (this.isApplyingCrop || this.croppedImageError || !this.croppedImage || !this.selectedFile) return;
        this.isApplyingCrop = true;
        const file = this.base64ToFile(
            this.croppedImage,
            this.getOutputFileName(this.selectedFile.name)
        );
        if (file.size > this.croppedImageMaxSize) {
            this.croppedImageError = 'Cropped image size must not exceed 1 MB.';
            this.isApplyingCrop = false;
            return;
        }

        this.profilepic = this.croppedImage;
        this.uploadedFiles = [file];
        this.acceptedProfileFile = file;
        if (this.fileUpload) {
            this.fileUpload.clear();
            this.fileUpload.files = [file];
        }
        this.cropApplied = true;
        this.cropDialog = false;
    }

    onCropCancel() {
        this.cropApplied = false;
        this.cropDialog = false;
    }

    onDialogHide() {
        if (!this.cropApplied) {
            this.restorePreviousImage();
        }
        this.resetCropState();
    }

    onProfilePhotoRemove() {
        this.uploadedFiles = [];
        this.profilepic = null;
        this.acceptedProfileFile = null;
    }

    private capturePreviousImage() {
        this.previousUploadedFiles = [...this.uploadedFiles];
        this.previousProfilepic = this.profilepic;
        this.previousAcceptedProfileFile = this.acceptedProfileFile;
    }

    private restorePreviousImage() {
        this.uploadedFiles = [...this.previousUploadedFiles];
        this.profilepic = this.previousProfilepic;
        this.acceptedProfileFile = this.previousAcceptedProfileFile;
        if (this.fileUpload) {
            this.fileUpload.clear();
            this.fileUpload.files = this.acceptedProfileFile ? [this.acceptedProfileFile] : [];
        }
    }

    private resetCropState() {
        this.imageChangedEvent = null;
        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = null;
        this.previousUploadedFiles = [];
        this.previousProfilepic = this.profilepic;
        this.previousAcceptedProfileFile = this.acceptedProfileFile;
        this.cropApplied = false;
        this.isApplyingCrop = false;
        this.resetZoom();
    }

    rejectOversizedImage() {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image no larger than 1 MB', life: 6000 });
        this.restorePreviousImage();
        this.resetCropState();
    }

    base64ToFile(data: string, filename: string): File {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    private getOutputFileName(filename: string | undefined): string {
        const baseName = (filename || 'profile-photo').replace(/\.[^/.]+$/, '');
        return `${baseName}.jpg`;
    }

    picUploader(event) {
        const files: File[] = event?.files || event;
        if (!files || files.length === 0) return;
        const file = files[0];
        this.uploadedFiles = [file];
        this.acceptedProfileFile = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.profilepic = reader.result;
        };
    }

    // getRoleid() {
    //     var querystring = "filterByroleName=admin";
    //     this.roleService.searchRoleDetails(querystring).subscribe(
    //         data => {
    //             this.adminRoleId = data.data.items[0]['id'];
    //         },
    //         err => {
    //             this.errorMessage = err.error.message;
    //         }
    //     );
    // }
    getRoleList() {
        var querystring = "filterByDisable=false&filterByStatus=true";
        this.rolearray = [];
        this.roleService.getRoleList(querystring).pipe(takeUntil(this.destroy$)).subscribe(
          (data) => {
            var roleList = data.data.items;
            roleList.forEach((element) => {
              this.rolearray.push({
                roleid: element.id,
                rolename: element.user_role_name,
              });
            });
           
          },
          (err) => {
            this.errorMessage = err.error.message;
          }
        );
      }

    getCountry() {
        this.commonService.getCountryList().pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.countrylist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    getStates(event) {
        //var countrycode = event.value.code;
        this.countryname = event.value.name;
        this.countrycode = event.value.code;
        this.commonService.getStateList(this.countrycode).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.statelist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    getCities(event) {
        this.statename = event.value.name;
        this.statecode = event.value.code;
        this.commonService.getCityList(this.statecode).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.citylist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    onStatusSelect(event) {
        if (event) {
            this.userstatus = event.value;
        }
    }

    onGenderSelect(event) {
        if (event) {
            this.usergender = event.name;
        }
    }

    onCitySelect(event) {
        this.cityname = event.value.name;
        this.citycode = event.value.code;
    }

    onTimezoneSelect(event) {
        this.timeZone = event.name;
        this.timeZoneOffset = event.code;
    }
    onRoleSelect(event){
        this.adminRoleId=event.roleid
    }

    onSubmit() {
        if (this.isSubmitting) {
            return;
        }
        this.submitted = true;
        // stop here if form is invalid
        if (this.userForm.invalid) {
            return;
        }
        var userData = this.userForm.value;
        userData['profilepic'] = this.profilepic;
        userData['role'] = this.adminRoleId;
        userData['status'] = this.userstatus;
        userData['gender'] = this.usergender;
        userData['countrycode'] = this.countrycode;
        userData['countryname'] = this.countryname;
        userData['statecode'] = this.statecode;
        userData['statename'] = this.statename;
        userData['citycode'] = this.citycode;
        userData['cityname'] = this.cityname;
        userData['timeZone'] = this.timeZone;
        userData['timeZoneOffset'] = this.timeZoneOffset;
        userData['dob'] = moment(this.userForm.value.dob).format("YYYY-MM-DD");

        //alert(this.countrycode+" "+this.countryname+"  "+this.statecode+" "+this.statename);
        //display form values on success
        console.log(JSON.stringify(this.userForm.value, null, 4));
        //alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.userForm.value, null, 4));
        //return;
        userData = JSON.stringify(userData, null, 4);
        // return;
        this.isSubmitting = true;
        this.userService.addUser(userData).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Admin Added', life: 6000 });
                setTimeout(() => {
                    this.router.navigate(['/manage/admin']);
                }, 2000);
            },
            ((err) => {
                this.isSubmitting = false;
                this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Admin failed', life: 6000 });
            })
        );
    }

    onReset() {
        this.submitted = false;
        this.userForm.reset();
    }

    backLink() {
        this.router.navigate(['/manage/admin']);
    }

    ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
